<template>
  <form-group :validator="v" :label="$t('pincode')">
    <input type="number"
     class="input"
      v-model="pincode"
       :placeholder= "$t('enterpincode')"
        @input="v.$touch()"
         />
  </form-group>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },

    v: {
      type: Object,
      required: true
    }
  },

  computed: {
    pincode: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
